import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import '../../styles/stripe-payment.scss';

/**
 * Redirects the user to a Stripe-hosted payment page.
 *
 * Stripe blocks iframe embedding (X-Frame-Options), so we redirect instead.
 * Shows a brief "redirecting…" message while the browser navigates.
 *
 * Props
 * ─────
 * @param {string} paymentLink – Full Stripe hosted invoice / payment URL
 */
function StripePayment({ paymentLink }) {
  const { t } = useTranslation();

  useEffect(() => {
    if (paymentLink) {
      const timer = setTimeout(() => {
        window.location.href = paymentLink;
      }, 800);
      return () => clearTimeout(timer);
    }
  }, [paymentLink]);

  if (!paymentLink) return null;

  return (
    <div className="stripe-payment">
      <div className="stripe-payment__redirecting">
        <div className="stripe-payment__spinner" />
        <p className="stripe-payment__text">
          {t('stripe_redirecting', 'Du skickas vidare till betalning...')}
        </p>
        <a className="stripe-payment__link" href={paymentLink} rel="noopener noreferrer">
          {t('stripe_click_here', 'Klicka här om du inte omdirigeras')}
        </a>
      </div>
    </div>
  );
}

export default StripePayment;
